<template>
  <div>
    <div class="top c-fl-bt c-p-20 c-bg-white">
      <div>共 <span>{{total}}</span>件商品</div>
      <div @click="toggleTxt">{{topTxt}}</div>
    </div>
    <g-line></g-line>
    <g-line></g-line>
    <div
      v-for="(v,i) in goodsCache"
      :key="i"
    >
      <van-swipe-cell>
        <div class="c-fl content c-p-20">
          <van-checkbox
            v-model="v.isChecked"
            @click="itemCheckHandler(v,i)"
            class="l-check"
          ></van-checkbox>
          <div class="l">
            <img
              :src="v.goodsImgUrl || $root.defaultImg"
              alt=""
              srcset=""
              class="l-img"
              mode="scaleToFill"
            >
          </div>
          <div class="r">
            <div class="r-top">
              <div class="main-title">{{v.Name}}</div>
              <div class="sub-title">{{v.GoodsList[0] && v.GoodsList[0].GoodsName}}
              </div>
            </div>
            <div class="r-bottom">
              <div class="c-fl-bt">
                <div>
                  <b v-if="v.MarketPrice">
                    <span class="c-yang c-tc">￥</span>
                    <span class="c-money c-m-r-10">{{v.MarketPrice}}</span>
                  </b>
                  <b
                    v-if="v.ScribePrice"
                    class="c-sub-money"
                  >
                    <span class="c-yang">￥</span>
                    <span class="c-money origin-color">{{v.ScribePrice}}</span>
                  </b>
                </div>
                <div class="add-r">
                  <div @click="goodsNumHandler('delete', v, i)">
                    <g-img
                      :src="require('@/assets/images/reduce_icon.png')"
                      :size="50"
                    ></g-img>
                  </div>
                  <div class="c">
                    {{v.goodsNum}}
                  </div>
                  <div @click="goodsNumHandler('add', v, i)">
                    <g-img
                      :src="require('@/assets/images/add_icon_active.png')"
                      :size="50"
                    ></g-img>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <template #right>
          <van-button
            @click="deleteItem(v, i)"
            square
            text="删除"
            type="danger"
            class="delete-button"
          />
        </template>
      </van-swipe-cell>
      <g-line></g-line>
    </div>

    <div class="c-fl-bt btm">
      <div
        class="b-l"
        @click="checkAll"
      >
        <van-checkbox
          v-model="isCheckAll"
          :disabled="isCheckAllDis"
        >全选</van-checkbox>
      </div>
      <div class="b-r c-f-ar">
        <span class="total-txt">合计: </span>
        <div>
          <span class="c-yang c-tc">￥</span><span class="c-money">{{totalMoney}}</span>
        </div>
        <div
          class="immediately-pay c-f-ar"
          :class="bottomTxt === '立即支付' ? '' : 'is-delete'"
          :style="isBottomDis && disObj"
          @click="immediatelyPay"
        >{{bottomTxt}}
        </div>
      </div>
    </div>
    <g-no-content
      v-if="goodsCache.length === 0"
      title="购物车里空空如也, 快去看看有什么好货吧"
      btnTxt="前往在线商城"
      @btnClick="toShopping"
    ></g-no-content>
  </div>
</template>

<script>
import { submitOrder } from '@/api/order'
export default {
  name: "ShoppingCard",
  props: {

  },
  data() {
    return {
      checked: true,
      total: 0,
      topTxt: '管理',
      isCheckAll: true,
      totalMoney: 0,
      bottomTxt: '立即支付',
      checkNum: 0,
      isCheckAllDis: false,
      isBottomDis: false,
      disObj: {
        background: '#aaa !important'
      }
    };
  },
  created() {
    this.init();
  },
  mounted() {

  },
  methods: {
    init() {
      const { $calc } = this;
      this.goodsCache = this.$pub.getS('goodsCache') || [];
      if (this.goodsCache.length === 0) {
        this.isCheckAll = false;
        this.isCheckAllDis = true;
        this.isBottomDis = true;
        return;
      }
      // this.goodsCache.forEach(v => {
      //   this.total += v.goodsNum;
      //   if (v.isChecked !== true) {
      //     this.isCheckAll = false;
      //   } else {
      //     // this.totalMoney += v.MarketPrice * v.goodsNum;
      //     // this.totalMoney = this.totalMoney + v.MarketPrice * v.goodsNum;
      //     let multy = $calc.multiply(v.MarketPrice, v.goodsNum);
      //     this.totalMoney = $calc.add(this.totalMoney, multy);
      //   }
      // })

      // this.goodsCache.map(v => {
      //   v.goodsBanners = [];
      //   return v;
      // })
      this.changePageStatus(true);
    },
    toShopping() {
      this.$router.push({
        name: 'HomePage'
      })
    },
    async immediatelyPay() {
      if (this.isBottomDis) {
        return this.$toast('请选择商品后重试');
      }
      // this.$router.push('payList');
      if (this.bottomTxt === '立即支付') {
        const Items = this.goodsCache.filter(v => {
          return v.isChecked;
        }).map(val => {
          let obj = {};
          obj.DistributorId = localStorage.getItem('distributorId');
          obj.ProductId = val.Id;
          obj.Quantity = val.goodsNum;
          return obj;
        })
        const requestParams = {
          Items: Items,
          VpnId: this.$store.state.vpnId,
        }
        const orderId = await submitOrder(requestParams)
        this.$router.push({
          name: 'PayList',
          query: { id: orderId }
        })
      } else {
        this.$dialog.confirm({
          title: '删除',
          message: '确定删除所选商品吗',
        })
          .then(() => {
            this.goodsCache = this.goodsCache.filter(v => {
              return v.isChecked !== true
            })
            this.changePageStatus();
          })
          .catch(() => {
            // on cancel
          });
      }
    },
    goodsNumHandler(handle, v, i) {
      if (handle === "add") {
        this.goodsCache[i].goodsNum++;
      }
      if (handle === "delete") {
        if (v.goodsNum === 1) {
          return this.$toast('购买数量不得低于1张')
        }
        this.goodsCache[i].goodsNum--;
      }
      this.changePageStatus(true);
    },
    toggleTxt() {
      this.changePageStatus();
    },
    // 全选
    checkAll() {
      if (this.goodsCache.length === 0) {
        return false;
      }
      this.goodsCache = this.goodsCache.map(v => {
        if (this.isCheckAll) {
          v.isChecked = false;
        } else {
          v.isChecked = true;
        }
        return v;
      });
      this.isCheckAll = !this.isCheckAll;
      this.changePageStatus(true);
    },
    deleteItem(v, i) {
      this.$dialog.confirm({
        title: '删除',
        message: '确定删除所选商品吗',
      })
        .then(() => {
          this.goodsCache.splice(i, 1);
          this.changePageStatus();
        })
        .catch(() => {
          // on cancel
        });
    },
    itemCheckHandler(v, i) {
      this.goodsCache[i].isChecked = this.goodsCache[i].isChecked ? true : false;
      this.isCheckAll = this.goodsCache.every(v => {
        return v.isChecked === true;
      });
      this.changePageStatus(true);
    },
    changePageStatus(txtNotChange) {
      const { $calc } = this;
      this.$pub.setS('goodsCache', this.goodsCache, true);
      this.totalMoney = 0;
      this.checkNum = 0;
      if (this.goodsCache.length === 0) {
        this.isCheckAllDis = true;
        this.totalMoney = 0;
        this.checkNum = 0;
        this.isBottomDis = true;
        this.total = 0;
      } else {
        let judgeBottomIsDis = false;
        this.goodsCache.forEach(v => {
          if (v.isChecked) {
            // this.totalMoney += v.MarketPrice * v.goodsNum;
            let multy = $calc.multiply(v.MarketPrice, v.goodsNum);
            this.totalMoney = $calc.add(this.totalMoney, multy);
            // this.checkNum += v.goodsNum;
            this.checkNum = $calc.add(v.goodsNum, this.checkNum);
            judgeBottomIsDis = true;
          } else {
            this.isCheckAll = false;
          }
        })
        if (judgeBottomIsDis) {
          this.isBottomDis = false;
        } else {
          this.isBottomDis = true;
        }
      }
      if (txtNotChange !== true) {
        if (this.topTxt === '管理') {
          this.topTxt = '完成';
          this.bottomTxt = '删除已选(' + this.checkNum + ')';
        } else {
          this.topTxt = '管理';
          this.bottomTxt = '立即支付'
        }
      } else {
        if (this.topTxt === '完成') {
          this.bottomTxt = '删除已选(' + this.checkNum + ')';
        }
      }
      this.$forceUpdate();
    },
  }
};
</script>
<style scoped lang='scss'>
.btm {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 96px;
  background: #ffffff;
  box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.02);
  box-sizing: border-box;
  width: 100%;
  .b-l {
    margin-left: 20px;
  }
  .immediately-pay {
    color: #fff;
    background: var(--tc);
    margin-left: 10px;
    width: 200px;
    height: 100%;
    /* display: flex;
    align-items: center;
    justify-content: space-around; */
  }
  .is-delete {
    opacity: 0.4;
    transition: 0.4s all;
  }
  .l-txt {
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #888888;
  }
  .r-txt {
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #333333;
  }
}
.all-check {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  margin-left: 10px;
}
.b-r {
  height: 100%;
}
.content {
  height: 200px;
  background: #fff;
  .f {
    flex: 1;
  }
  .l-img {
    width: 200px;
    /* height: 200px; */
  }
  .l-check {
    margin-right: 10px;
  }
  .r {
    flex: 2;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 200px;
    width: 100%;
  }
  .r-top {
    .main-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .sub-title {
      font-size: 22px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      margin-top: 20px;
    }
  }
  .r-bottom {
    .change-color {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--tc);
      margin-right: 10px;
    }
    .origin-color {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      text-decoration: line-through;
    }
  }
}
.add-r {
  width: 200px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 20px; */
}
.c {
  font-size: 30px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #333333;
}
.total-txt {
  margin-right: 10px;
}
</style>
